import React from 'react';
import { Banner as BannerType } from '@v2/shared/lib/types';
import Banner from '@v2/shared/components/Banner';

type Props = {
  banner?: BannerType;
};

export default function SingleBanner({ banner }: Props) {
  return (
    <div className="grid grid-cols-12 gap-y-8 md:gap-8 mb-10 lg:mb-16">
      <div className="col-span-12">
        <div className="">
          {banner && (
            <Banner
              banner={banner}
              wrapperClassName="h-40 md:h-56 lg:h-72 rounded-lg lg:rounded-xl block overflow-hidden"
              imageClassName="h-full w-full object-cover object-left"
            />
          )}
        </div>
      </div>
    </div>
  );
}
